import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-rc-view-actions-bar',
  templateUrl: './rc-view-actions-bar.component.html',
  styleUrls: ['./rc-view-actions-bar.component.scss'],
  standalone: false,
})
export class RcViewActionsBarComponent {
  @Input() public isLegendVisible = false

  @Output() public toggleLegend = new EventEmitter<void>()
}
